document.querySelectorAll('.ModalSelectDistrict').forEach((modal) => {
    new ModalCounter(modal, '.FormNearMetroList__list input', declensionDistrict);
    const searchableInput = modal.querySelector('.SearchableInput');

    searchableInput.addEventListener('select', (e) => {
        const input = modal.querySelector(`input[value="${e.detail.value}"]`);
        if(input) {
            input.checked = true;
        }
    });
})
